import React from 'react'
import { IconSVGType } from '../../../types/icons'

export const EmvChipIcon = (props: IconSVGType) => {
  return (
    <svg
      width='27'
      height='19'
      viewBox='0 0 27 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 5.06667C0 2.26842 2.30254 0 5.14286 0H21.8571C24.6975 0 27 2.26842 27 5.06667V13.9333C27 16.7316 24.6975 19 21.8571 19H5.14286C2.30254 19 0 16.7316 0 13.9333V5.06667Z'
        fill='white'
        fillOpacity='0.2'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.4576 6.33333C11.7017 6.35531 10.2851 7.76454 10.2851 9.49974C10.2851 11.2486 11.7241 12.6664 13.4992 12.6664C15.2743 12.6664 16.7133 11.2486 16.7133 9.49974C16.7133 7.76454 15.2968 6.35531 13.5409 6.33333L13.4576 6.33333ZM14.1418 5.11127C15.4528 5.29595 16.5816 6.03742 17.2734 7.08477L20.8858 4.97493L27.0057 4.97493L26.9912 6.25407L21.2163 6.25407L17.8149 8.24062C17.8758 8.44376 17.9224 8.65297 17.9535 8.86712L26.9985 8.86712V10.1338L17.9533 10.1338C17.8954 10.5318 17.7839 10.9128 17.6262 11.2693L21.2163 13.366L26.9912 13.366L27.0057 14.6452L20.8858 14.6452L16.9492 12.346C16.2538 13.1634 15.2646 13.73 14.1418 13.8882V19.0003H12.8561L12.8561 13.8881C11.7792 13.7363 10.8253 13.2088 10.1356 12.4446L6.27882 14.6384H0.00011365L0.000113612 13.3718L5.93433 13.3718L9.4258 11.3857C9.23964 10.9961 9.10938 10.5754 9.04518 10.1338L0 10.1338L1.12395e-07 8.86712L9.04497 8.86712C9.08229 8.60982 9.14202 8.35965 9.22217 8.11858L5.93433 6.24835H0.000113612L0.00011365 4.98168L6.27882 4.98168L9.79514 6.98188C10.4916 5.98913 11.5887 5.29004 12.8561 5.11134L12.8561 0H14.1418V5.11127Z'
        fill='white'
        fillOpacity='0.2'
      />
    </svg>
  )
}
